import * as React from 'react';

import { Button } from '@origin-digital/ods-core';
import { FindPlan, PostCodeInput } from '../../../../FindPlan';
import { getUserPostcodeValue, DEFAULTS } from '../../../../../utils/utils';
import { RippleLine } from '../RippleLine';
import { TransparentCard, PostcodeInputContainer } from './BannerPostcodePrompt.styles';
import getUserLocation from '../../../../GeoTargetting/GeoTargetting';

export const getUserPostcode = async (setPlaceholder) => {
  const userLocation = await getUserLocation();
  if (userLocation) {
    const { postcode } = getUserPostcodeValue(userLocation);
    setPlaceholder(postcode);
  }
};

export const UnwrappedBannerPostcodePrompt = ({ buttonUrl, active, ...postcodeInputProps }) => {
  const [placeholder, setPlaceholder] = React.useState(`${DEFAULTS.region.defaultPostcode}`);

  React.useEffect(() => {
    getUserPostcode(setPlaceholder);
  }, []);

  return (
    <TransparentCard>
      <PostcodeInputContainer>
        <PostCodeInput
          {...postcodeInputProps}
          inputmode="numeric"
          pattern="[0-9]*"
          title="Postal Code"
          placeholder={placeholder}
          type="tel"
        />
        <RippleLine active={active} />
      </PostcodeInputContainer>
      <Button href={buttonUrl} data-id={`banner-compare-energy-plans`}>
        See energy plans
      </Button>
    </TransparentCard>
  );
};

export const BannerPostcodePrompt = () => {
  return (
    <FindPlan
      component={UnwrappedBannerPostcodePrompt}
      trackingId="banner-postcode-input"
      trackingLabel="Banner See energy plans"
      buttonUrl="/electricity-gas/plans.html"
    />
  );
};

BannerPostcodePrompt.displayName = 'BannerPostcodePrompt';
